import React, { useRef } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import type { UploadConfig } from '../../domain/entities/UploadConfig.js';

interface Props {
  config: UploadConfig;
  onFiles: (files: FileList) => void;
  size?: number;
}

export function UploadPickerButton({ config, onFiles, size = 100 }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { token } = theme.useToken();

  const accept = config.accept ?? (config.enableAudio
    ? 'image/*,audio/*'
    : 'image/*');

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        multiple={config.allowMultiple !== false}
        style={{ display: 'none' }}
        onChange={(e) => {
          if (e.target.files?.length) {
            onFiles(e.target.files);
            e.target.value = '';
          }
        }}
      />
      <div
        onClick={() => inputRef.current?.click()}
        style={{
          width: size,
          height: size,
          border: `1.5px dashed ${token.colorBorder}`,
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          background: token.colorFillTertiary,
          flexShrink: 0,
        }}
        onMouseEnter={(e) => { (e.currentTarget as HTMLDivElement).style.borderColor = token.colorPrimary; }}
        onMouseLeave={(e) => { (e.currentTarget as HTMLDivElement).style.borderColor = token.colorBorder; }}
      >
        <PlusOutlined style={{ fontSize: 20, color: token.colorTextQuaternary }} />
      </div>
    </>
  );
}
